module.exports = __webpack_public_path__ + "img/browser-opera-logo.6b2c8e1a.png";